module.exports = __webpack_public_path__ + "img/D100_04.a0250d55.png";